export default function contactForm() {
	return {
		fullName: '',
		email: '',
		phone: '',
		message: '',
		consent: false,
		errors: [],
		successMessage: '',

		submitForm(e) {
			e.preventDefault()

			this.errors = []

			// Validate the fields
			if (!this.fullName) {
				this.errors.push('Full name is required.')
			}

			if (!this.email || !this.isValidEmail(this.email)) {
				this.errors.push('Please enter a valid email address.')
			}

			if (!this.phone) {
				this.errors.push('Phone number is required.')
			}

			if (!this.message) {
				this.errors.push('Message is required.')
			}

			if (!this.consent) {
				this.errors.push('You must agree to the terms and conditions.')
			}

			if (!this.errors.length) {
				this.errors = []

				// If validation passes, show success message
				this.successMessage = 'Your message has been sent!'
				this.clearForm()
				e.target.submit()
			}
		},

		// Clear the form after submission
		clearForm() {
			this.fullName = '';
			this.email = '';
			this.phone = '';
			this.message = '';
			this.consent = false;
		},

		isValidEmail(email) {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailPattern.test(email);
		}
	}
}
